var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVimeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5317 9.43147V5.59127C18.6845 5.59127 17.2748 5.11125 16.3651 4.17824C15.4314 3.11343 14.9083 1.76497 14.8859 0.365089V0.0878919L11.1567 0C11.1567 0 11.1567 0.155501 11.1567 0.365089V15.5974C11.0288 16.2779 10.6895 16.9039 10.1846 17.3907C9.67972 17.8775 9.03356 18.2018 8.33336 18.3198C7.63316 18.4378 6.91264 18.3438 6.26906 18.0504C5.62549 17.7571 5.08985 17.2786 4.73446 16.6795C4.37907 16.0804 4.22103 15.3896 4.2817 14.7003C4.34236 14.011 4.61879 13.3564 5.07368 12.8249C5.52857 12.2934 6.14001 11.9106 6.82546 11.7281C7.51091 11.5456 8.23736 11.5723 8.90674 11.8045V8.08605C8.51646 8.02379 8.12167 7.99214 7.72618 7.99139C6.30326 7.99139 4.91229 8.40219 3.72917 9.17183C2.54605 9.94147 1.62392 11.0354 1.07939 12.3153C0.534855 13.5951 0.392382 15.0035 0.669981 16.3622C0.94758 17.7209 1.63278 18.9689 2.63895 19.9485C3.64511 20.9281 4.92703 21.5951 6.32262 21.8654C7.7182 22.1357 9.16477 21.997 10.4794 21.4668C11.794 20.9367 12.9176 20.0389 13.7081 18.8871C14.4987 17.7352 14.9206 16.381 14.9206 14.9957C14.9199 14.7087 14.9013 14.4219 14.8651 14.1371V7.95083C16.5608 8.98183 18.5337 9.49732 20.5317 9.43147Z",
    fill: "#273043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.fa87eaeb4c14c5a1b4d5ab2453b1e72a.svg";
export { ForwardRef as ReactComponent };